<template>
    <div
        class="relative flex items-center flex-grow w-full col-span-1 px-4 py-6 mb-4 bg-white border border-gray-200 shadow-sm rounded-"
    >
        <div
            @click="show = !show"
            class="absolute top-0 right-0 flex items-center justify-center w-8 h-8 text-gray-500 border-b border-l border-gray-100 cursor-pointer hover:text-gray-900"
        >
            <svg
                v-show="show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                ></path>
            </svg>
            <svg
                v-show="!show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                ></path>
            </svg>
        </div>
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
            <div class="max-w-4xl mx-auto">
                <div class="flex justify-between" v-show="show">
                    <h2
                        @click="show = !show"
                        class="text-xl font-extrabold leading-9 text-left text-blue-600 cursor-pointer sm:text-xl sm:leading-10"
                    >
                        {{ offer.name }}
                    </h2>

                    <div @click="removeOffer">
                        <base-icon
                            width="60"
                            height="60"
                            class="h-8 cursor-pointer"
                            icon-name="trash"
                            viewBox="0 0 20 20 "
                            iconColor="#6C98C6"
                        >
                            <icon-trash />
                        </base-icon>
                    </div>
                </div>
                <div v-show="!show">
                    <tag-group :tags="tags" @clicked="checkOfferType" />
                    <base-input
                        placeholder="Nom du Produit/Service"
                        v-model="offer.name"
                        :hasError="$v.offer.name.$error"
                        :errorMessage="
                            errorMessage(
                                'Nom du Produit ou Service',
                                $v.offer.name
                            )
                        "
                        @blur="$v.offer.name.$touch()"
                    />
                    <base-input
                        placeholder="Description du Produit/Service"
                        v-model="offer.description"
                        :hasError="$v.offer.description.$error"
                        :errorMessage="
                            errorMessage(
                                'Description du Produit/Service',
                                $v.offer.description
                            )
                        "
                        @blur="$v.offer.description.$touch()"
                    />

                    <div class="flex justify-end mt-4 ">
                        <base-secondary-button
                            color="red"
                            title="Supprimer"
                            @click="removeOffer"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TagGroup from "@/components/forms/TagGroup";
import IconTrash from "@/components/icons/trash";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";

export default {
    components: { TagGroup, IconTrash },

    mixins: [errorMessage],

    validations: {
        offer: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(75)
            },
            description: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(200)
            }
        }
    },

    props: {
        data: {
            type: Object
        },
        title: {
            type: String
        }
    },
    mounted() {
        this.tags.forEach(elem => {
            if (elem.value === this.data.type) elem.isActive = true;
        });
    },

    data() {
        return {
            show: false,
            /*offer: this.createFreshOfferObject(),*/
            offer: this.data,
            tags: [
                { name: "Produit", value: "product", isActive: false },
                { name: "Service", value: "service", isActive: false }
            ]
        };
    },
    methods: {
        checkOfferType(e) {
            this.offer.type = e;
        },

        createFreshOfferObject() {
            const id = Math.floor(Math.random() * 100000000);

            return {
                id: id,
                name: "",
                description: "",
                type: ""
            };
        },
        createOffer() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                /*this.offer.type = this.offer_type;*/
                this.$store.dispatch("VotreProject/addOffer", this.offer);
                this.show = true;
                return true;
            } else {
                this.show = false;
                return false;
            }
        },
        removeOffer() {
            this.$emit("remove", this.offer.id);
        }
    }
};
</script>

<style></style>
